import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import NADLRecordForm from 'app/gears/nadl/components/NADLRecordForm'
import NADLRecordResults from 'app/gears/nadl/components/NADLRecordResults'
import { fetchRecords } from 'app/gears/nadl/actions/nadlActions'
import LgyLinkButton from 'app/components/util/lgy-link-button/LgyLinkButton'

let NADLRecordMaintenance = ({ canEditRecords, canEditDocuments, nadlRecords, fetchRecords, fetching }) => {
  const [adding, setAdding] = useState(false)
  const [focusing, setFocusing] = useState(false)
  const [recordToFocus, setRecordToFocus] = useState({})

  useEffect(() => {
    if (!nadlRecords) {
      fetchRecords()
    }
  }, [nadlRecords, fetchRecords])

  const handleAdd = (e) => {
    e.preventDefault()
    setRecordToFocus({})
    setFocusing(false)
    setAdding(true)
  }

  const handleFocus = (key) => {
    setRecordToFocus(nadlRecords.find(record => record.id === key))
    setFocusing(true)
    setAdding(false)
  }

  const handleReset = () => {
    setRecordToFocus(null)
    setAdding(false)
    setFocusing(false)
  }
  const columns = React.useMemo(
    () => [
      {
        Header: 'NADL Records',
        columns: [
          {
            Header: "Id",
            accessor: "id"
          },
          {
            Header: 'Commitment Date',
            accessor: 'dateCommitmentIssued'
          },
          {
            Header: 'LIN',
            accessor: 'lin',
          },
          {
            Header: 'MOU No',
            accessor: 'mouNo',
          },
          {
            Header: 'First Name',
            accessor: 'firstName'
          }, {
            Header: 'Middle Initial',
            accessor: 'mi'
          },
          {
            Header: 'Last Name',
            accessor: 'lastName'
          },
          {
            Header: 'ALAC Receipt Date',
            accessor: 'alacReceiptDate'
          },
          {
            Header: 'Date Added',
            accessor: 'dateAdded',
          },
          {
            Header: '',
            accessor: 'viewEditButton'
          }
        ],
      },
    ],
    []
  )

  return (
    <div>
      <h3>Native American Direct Loan Record Maintenance</h3>
      {!adding && !focusing &&
        <>
          <p>Every loan registered with NADL is listed below. You can click the <b>View{canEditRecords && '/Edit'}</b> button
             next to a listing to see more details {canEditRecords && ' or edit the record.'}</p>
          <p>You can click on a column header to sort it, or use the Search text box below it to filter for certain values.</p>
          {canEditRecords && <p>To add a new record, please click <LgyLinkButton onClick={(e) => handleAdd(e)}>here</LgyLinkButton>.</p>}
          {!fetching && nadlRecords ?
            <NADLRecordResults
              handleFocus={handleFocus}
              columns={columns}
              data={nadlRecords.reverse()} // Show most recently added first
              canEditRecords={canEditRecords} />
            : <span><h4>Loading...</h4></span>}
        </>}
      {(adding || focusing) &&
        <NADLRecordForm
          adding={adding}
          focusing={focusing}
          canEditRecords={canEditRecords}
          canEditDocuments={canEditDocuments}
          handleReset={handleReset}
          recordToFocus={recordToFocus} />}
    </div>
  )
}

const mapStateToProps = state => ({
  ...state.nadlRecords
})
const mapDispatchToProps = { fetchRecords }

NADLRecordMaintenance = connect(mapStateToProps, mapDispatchToProps)(NADLRecordMaintenance)

export default NADLRecordMaintenance
